import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Main } from './component/Main';
import './styles/global.scss';
import 'aos/dist/aos.css';
import AOS from 'aos';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1200, 
      once: true, 
    });
  }, []);

  return (
    <Router>
      <Main /> 
    </Router>
  );
}

export default App;